import React, { useEffect, useState } from "react";
import Footer from "../../../../Kryzen Alpha App/Components/Footer/footer";
import StepRoutes from "../../../../Kryzen Alpha App/Routes/steps_routes";
import { useNavigate, useParams } from "react-router-dom";
import LoadingPage from "../../../../Kryzen Alpha App/Components/layouts/loading";
import { Toast } from "../../../../Kryzen Alpha App/CustomComponent/toast";
import performRequest from "../../../../Kryzen Alpha App/api/request";
import { CustomErrorResponse } from "../../../CustomComponent/custom_error_response";
import { FcVoicePresentation } from "react-icons/fc";
import SimpleButton from "../../../Components/layouts/simple_button";
import { LazyImageComponent } from "../../../CustomComponent/lazy_loading_image";
import { LeadInfo } from "../../../SchemaInfo/info";
import { useSelector } from "react-redux";

const getName = (lead) => {
  if (lead.fullName) {
    return lead.fullName;
  }
  if (lead.firstName && lead.lastName) {
    return `${lead.firstName} ${lead.lastName}`;
  }
  if (lead.firstName) {
    return lead.firstName;
  }
  if (lead.lastName) {
    return lead.lastName;
  }
  return "N/A";
};
const ViewNhmApplicants = () => {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState();
  const navigate = useNavigate();
  const [refresh, setRefresh] = useState(false);
  const store = useSelector((store) => store.login.user);
  let { id } = useParams();
  useEffect(() => {
    setLoading(true);
    performRequest("GET", `/nhm-applicants/getNHMApplicantsById/${id}`)
      .then((res) => {
        if (res.status === 200) {
          setData(res.data);
          // console.log(data);
        } else {
          Toast("error", "Error while getting Expense!");
        }
        setLoading(false);
      })

      .catch((err) => {
        // Toast("error", "Server Error!");
        // console.error(err);
        CustomErrorResponse(err);
      })
      .finally(() => setLoading(false));
  }, [id, refresh]);
  const updateStatus = (values) => {
    let formData = new FormData();
    for (let key in values) {
      formData.append(key, values[key]);
    }
    const headers = { "Content-Type": "multipart/form-data" };

    setLoading(true);
    performRequest(
      "PATCH",
      `/nhm-applicants/updateNHMApplicants/${values.MobileMask}`,
      formData,
      headers
    )
      .then((res) => {
        if (res.status === 200) {
          Toast("success", "status updated successfully!");
        } else {
          Toast("error", "Error while uploading");
        }
      })
      .catch((err) => {
        CustomErrorResponse(err);
      })
      .finally(() => setLoading(false));
  };
  const AddAndAssignLead = (values) => {
    let lead = {
      ...LeadInfo,
      first_name: values.Name || "",
      last_name: "",
      interestedIn: [],
      full_name: values.Name || "",
      services: "",
      planned_area: values.areaSqM || "",
      location_type: "",
      company_name: "",
      lead_genrated_from: "nhm-applicants",
      lead_alloted_to: store.Name || "",
      reAssignTo: store.Name || "",
      preferred_contact_method: "",
      phone_number: values.Mobile || values?.alterContactNo || "",
      lead_status: "hot",
      email: "",
      gst_number: "",
      address: values.Village + ", " + values.Taluka + ", " + values.District,
      notes: "",
    };
    setLoading(true);
    performRequest("POST", "/leads/createleads", lead)
      .then((res) => {
        if (res.status === 201) {
          updateStatus({ addedInLead: true, MobileMask: data?.MobileMask });
          setTimeout(() => {
            Toast("success", "Leads generated successfully!");
            if (res.data.id) {
              navigate(`/leads/edit-lead/${res.data.id}`);
            }
          }, 500);
        } else if (res.status === 200) {
          updateStatus({ addedInLead: true, MobileMask: data?.MobileMask });
          Toast("error", res.data.message);
          if (res.data.id) {
            navigate(`/leads/edit-lead/${res.data.id}`);
          }
          setRefresh(!refresh);
        } else {
          Toast("error", "Error while uploading");
        }
      })
      .catch((err) => {
        CustomErrorResponse("Error", err);
      })
      .finally(() => setLoading(false));
  };

  if (loading) {
    return <LoadingPage />;
  }

  return (
    <div className="page">
      <div className="page-wrapper">
        <div className="container-xl">
          <div className="page-header d-print-none">
            <div className="row g-2 align-items-center">
              <div className="col">
                <h2 className="page-title mb-1">
                  <FcVoicePresentation /> View NHM Applicants
                </h2>
                <h4 className="text-muted">
                  <StepRoutes />
                </h4>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-12 col-md-3">
              {" "}
              {/* FORM FOR ELIGIBILITY CHECK */}
              <div className="card my-4">
                <div className="card-header bg-success-lt">
                  <h2 className="page-title"> आवश्यक कागदपत्रे </h2>
                </div>
                <div className="card-body">
                  <ul className="list-group list-group-flush">
                    <li className="list-group-item">
                      अर्जदाराचा ७/१२ व ८ अ उतारा
                    </li>
                    <li className="list-group-item">
                      अनुसूचित जाती किंवा जमाती प्रवर्गातील असल्यास त्याबाबतचा
                      पुरावा
                    </li>
                    <li className="list-group-item">
                      अर्जदार दिव्यांग असल्यास त्याचे प्रमाणपत्र
                    </li>
                    <li className="list-group-item">
                      शेडनेट हाऊस संदर्भातील प्रशिक्षण प्रमाणपत्र
                    </li>
                  </ul>
                </div>
              </div>
              <div className="card my-4">
                <div className="card-header bg-success-lt">
                  <h2 className="page-title"> शेती अनुदानाची माहिती </h2>
                </div>
                <div className="card-body">
                  <ul className="list-group list-group-flush">
                    <li className="list-group-item">
                      अनुदान टक्केवारी :{" "}
                      {data?.subsidyPercent?.toString() + " %" || "उपलब्ध नाही"}
                    </li>
                    <li className="list-group-item">
                      कमाल अनुदान (रु.) :{" "}
                      {data?.maxSubsidyRs?.toString() || "उपलब्ध नाही"}
                    </li>
                    <li className="list-group-item">
                      एकूण अर्ज :{" "}
                      {data?.applications?.toString() || "उपलब्ध नाही"}
                    </li>
                    <li className="list-group-item">
                      पूर्व मंजुरी संख्या :{" "}
                      {data?.preSanction?.toString() || "उपलब्ध नाही"}
                    </li>
                    <li className="list-group-item">
                      वितरण संख्या :{" "}
                      {data?.disbursementCount?.toString() || "उपलब्ध नाही"}
                    </li>
                  </ul>
                </div>
              </div>
              <div className="card my-4">
                <div className="card-header bg-success-lt ">
                  <h2 className="page-title"> पात्रता निकष </h2>
                </div>
                <div className="card-body">
                  <ul className="list-group list-group-flush">
                    <li className="list-group-item">
                      ग्राम कृषि संजीवनी समितीने मान्यता दिलेले अत्यल्प व अल्प
                      भूधारक शेतकरी, २ ते ५ हेक्टर जमीनधारणा असलेले शेतकरी तसेच
                      अनु.जाती/जमाती, महिला, दिव्यांग शेतकऱ्यांना प्राधान्य.
                    </li>
                    <li className="list-group-item">
                      पूर्वी इतर योजनेचा लाभ घेतल्यास एकत्रित मर्यादा ४० गुंठे.
                    </li>
                    <li className="list-group-item">
                      स्वतःची जमीन, पाणी व वीजपुरवठा आवश्यक.
                    </li>
                    <li className="list-group-item">
                      सेवा पुरवठादाराकडून तांत्रिक निकषानुसार उभारणी केल्याचे
                      प्रमाणपत्र आवश्यक.
                    </li>
                    <li className="list-group-item">
                      ५०० चौ.मी. ते ४००० चौ.मी. पर्यंत क्षेत्र मर्यादा.
                    </li>
                    <li className="list-group-item">
                      शेडनेट हाऊस प्रशिक्षण अनुदान अदायगीपूर्वी घेणे आवश्यक.
                    </li>
                    <li className="list-group-item">
                      तांत्रिक निकष व आराखडा मार्गदर्शक सूचनांनुसार ग्राह्य
                      धरण्यात येईल.
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div className="col-12 col-md-9">
              <div className="card my-4">
                <div className="card-header">
                  <h2 className="page-title"> View NHM Applicants Details</h2>
                </div>

                <div className="card-body">
                  {data && (
                    <div className="mb-3 row">
                      <label className="w-25 form-label col-3">Name :</label>
                      <div className="w-100 col">
                        {data?.Name.toUpperCase() || "N/A"}
                      </div>
                    </div>
                  )}
                  {data && (
                    <div className="mb-3 row">
                      <label className="w-25 form-label col-3">
                        Contact Number :
                      </label>
                      <div className="w-100 col">{data?.Mobile || "N/A"}</div>
                    </div>
                  )}
                  {data && (
                    <div className="mb-3 row">
                      <label className="w-25 form-label col-3">
                        Alternative Number :
                      </label>
                      <div className="w-100 col">
                        {data?.alterContactNo || "N/A"}
                      </div>
                    </div>
                  )}
                  {data && (
                    <div className="mb-3 row">
                      <label className="w-25 form-label col-3">Village :</label>
                      <div className="w-100 col">
                        {data?.Village.toUpperCase() || "N/A"}
                      </div>
                    </div>
                  )}

                  {data && (
                    <div className="mb-3 row">
                      <label className="w-25 form-label col-3">Taluka :</label>
                      <div className="w-100 col">
                        {data?.Taluka.toUpperCase() || "N/A"}
                      </div>
                    </div>
                  )}
                  {data && (
                    <div className="mb-3 row">
                      <label className="w-25 form-label col-3">
                        District :
                      </label>
                      <div className="w-100 col">
                        {data?.District.toUpperCase() || "N/A"}
                      </div>
                    </div>
                  )}
                  {data && (
                    <div className="mb-3 row">
                      <label className="w-25 form-label col-3">
                        Structure :
                      </label>
                      <div className="w-100 col">
                        {data?.Structure.toUpperCase() || "N/A"}
                      </div>
                    </div>
                  )}
                  {data && (
                    <div className="mb-3 row">
                      <label className="w-25 form-label col-3">System :</label>
                      <div className="w-100 col">
                        {data?.System.toUpperCase() || "N/A"}
                      </div>
                    </div>
                  )}
                  {data && (
                    <div className="mb-3 row">
                      <label className="w-25 form-label col-3">
                        TubularStructure :
                      </label>
                      <div className="w-100 col">
                        {data?.TubularStructure.toUpperCase() || "N/A"}
                      </div>
                    </div>
                  )}
                  <div className="mb-3 row">
                    <label className="w-25 form-label col-3">Area : </label>
                    <div className="w-100 col">{data?.Area || "N/A"}</div>
                  </div>
                  <div className="mb-3 row">
                    <label className="w-25 form-label col-3">Code : </label>
                    <div className="w-100 col">{data?.code || "N/A"}</div>
                  </div>
                  <div className="mb-3 row">
                    <label className="w-25 form-label col-3">
                      Type Code :{" "}
                    </label>
                    <div className="w-100 col">{data?.typeCode || "N/A"}</div>
                  </div>
                  <div className="mb-3 row">
                    <label className="w-25 form-label col-3">Size : </label>
                    <div className="w-100 col">{data?.size || "N/A"}</div>
                  </div>
                  <div className="mb-3 row">
                    <label className="w-25 form-label col-3">Area SqM : </label>
                    <div className="w-100 col">{data?.areaSqM || "N/A"}</div>
                  </div>
                  <div className="mb-3 row">
                    <label className="w-25 form-label col-3">
                      Subsidy Percent :{" "}
                    </label>
                    <div className="w-100 col">
                      {data?.subsidyPercent || "N/A"}
                    </div>
                  </div>
                  <div className="mb-3 row">
                    <label className="w-25 form-label col-3">
                      Max Subsidy(Rs) :{" "}
                    </label>
                    <div className="w-100 col">
                      {data?.maxSubsidyRs || "N/A"}
                    </div>
                  </div>
                  <div className="mb-3 row">
                    <label className="w-25 form-label col-3">
                      Applications :{" "}
                    </label>
                    <div className="w-100 col">
                      {data?.applications || "N/A"}
                    </div>
                  </div>
                  <div className="mb-3 row">
                    <label className="w-25 form-label col-3">
                      Pre Sanction :{" "}
                    </label>
                    <div className="w-100 col">
                      {data?.preSanction || "N/A"}
                    </div>
                  </div>
                  <div className="mb-3 row">
                    <label className="w-25 form-label col-3">
                      DisbursementCount :{" "}
                    </label>
                    <div className="w-100 col">
                      {data?.disbursementCount || "N/A"}
                    </div>
                  </div>
                  <div className="mb-3 row">
                    <label className="w-25 form-label col-3">
                      Disbursed(Rs) :{" "}
                    </label>
                    <div className="w-100 col">
                      {data?.disbursedRs || "N/A"}
                    </div>
                  </div>
                  <div className="mb-3 row">
                    <label className="w-25 form-label col-3">
                      MobileMask:{" "}
                    </label>
                    <div className="w-100 col">{data?.MobileMask || "N/A"}</div>
                  </div>
                  <hr></hr>

                  <div className="mb-3 row">
                    <label className="w-25 form-label col-3">
                      Looking for a bank loan :{" "}
                    </label>

                    <div className="w-100 col">{data?.bankLoan || "N/A"}</div>
                  </div>

                  <div className="mb-3 row">
                    <label className="w-25 form-label col-3">
                      Possible start date :{" "}
                    </label>
                    <div className="w-100 col">{data?.tenDate || "N/A"}</div>
                  </div>

                  <div className="mb-3 row">
                    <label className="w-25 form-label col-3">
                      Applicant's 7/12
                    </label>
                    <div className="w-100 col">
                      {data?.satbaraDoc ? (
                        <LazyImageComponent
                          width="70%"
                          src={data.satbaraDoc}
                          alt="Applicant's 7/12 photo"
                        />
                      ) : (
                        "Applicant's 7/12 Not Available"
                      )}
                    </div>
                  </div>

                  <hr></hr>

                  <div className="mb-3 row">
                    <label className="w-25 form-label col-3">
                      {" "}
                      Applicant's 8A extract:
                    </label>
                    <div className="w-100 col">
                      {data?.utaraDoc ? (
                        <LazyImageComponent
                          width="70%"
                          src={data.utaraDoc}
                          alt="Applicant's 8A extract photo"
                        />
                      ) : (
                        "Applicant's 8A extract Not Available"
                      )}
                    </div>
                  </div>
                  <hr></hr>

                  <div className="mb-3 row">
                    <label className="w-25 form-label col-3">
                      Proof of belonging to Scheduled Caste or Scheduled Tribe
                      category:{" "}
                    </label>
                    <div className="w-100 col">
                      {data?.castDoc ? (
                        <LazyImageComponent
                          width="70%"
                          src={data.castDoc}
                          alt="8A Utara Doc photo"
                        />
                      ) : (
                        "8A Utara Doc Not Available"
                      )}
                    </div>
                  </div>
                  <hr></hr>

                  <div className="mb-3 row">
                    <label className="w-25 form-label col-3">
                      If the applicant is disabled, his/her certificate:{" "}
                    </label>
                    <div className="w-100 col">
                      {data?.certiDoc ? (
                        <LazyImageComponent
                          width="70%"
                          src={data.certiDoc}
                          alt="If the applicant is disabled, his/her certificate"
                        />
                      ) : (
                        "If the applicant is disabled, his/her certificate"
                      )}
                    </div>
                  </div>
                  <hr></hr>

                  <div className="mb-3 row">
                    <label className="w-25 form-label col-3">
                      Training Certificate in relation to Shednet House:{" "}
                    </label>
                    <div className="w-100 col">
                      {data?.studyDoc ? (
                        <LazyImageComponent
                          width="70%"
                          src={data.studyDoc}
                          alt="Training Certificate in relation to Shednet House
"
                        />
                      ) : (
                        "Training Certificate in relation to Shednet House"
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="card-footer">
              <div className="btn-list justify-content-end">
                <button
                  className="btn mx-1 mt-2 btn-primary"
                  disabled={data?.addedInLead}
                  onClick={() => AddAndAssignLead(data)}
                >
                  CREATE LEAD
                </button>
                <SimpleButton
                  href={`/edit-nhm-applicants/${id}`}
                  buttonText="Edit Information"
                  type="primary"
                />
                <SimpleButton buttonText="Cancel" type="secondary" />
              </div>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default ViewNhmApplicants;
